
import { CalendarDays, Ticket, BarChart, Megaphone, Users, Trophy, Sparkles, Link, Target } from "lucide-react";
import { DashboardFeature } from "./types";

export const promoterFeatures: DashboardFeature[] = [
  {
    icon: Sparkles,
    title: "Smart Dashboard",
    description: "AI-powered promoter management hub",
    href: "/dashboard/promoter/management",
  },
  {
    icon: Target,
    title: "Tasks & Rewards",
    description: "Complete tasks and unlock rewards",
    href: "/dashboard/promoter/management",
  },
  {
    icon: Link,
    title: "Tracking Links",
    description: "Generate and track promotional links",
    href: "/dashboard/promoter/management",
  },
  {
    icon: Users,
    title: "Guest Lists",
    description: "Manage guest lists with discounts",
    href: "/dashboard/guest-lists",
  },
  {
    icon: Trophy,
    title: "Performance",
    description: "View your promoter scorecard",
    href: "/dashboard/promoter/performance",
  },
  {
    icon: BarChart,
    title: "Analytics",
    description: "Track event performance and revenue",
    href: "/dashboard/events/analytics",
  }
];
